import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import { GetCustomFieldsDto } from '../autogenerated/spdApiClient';

export interface CustomFieldsContextInterface {
  get: (id: string) => Promise<GetCustomFieldsDto>;
  getAll: () => Promise<GetCustomFieldsDto[]>;
}

export const CustomFieldsContext = (api: DefaultApi) => {
  return {
    get: (id: string) => api.customFieldsControllerGet(id),
    getAll: () => api.customFieldsControllerGetAll(),
  };
};
